import { Component } from '@angular/core';
import { LanguagesDialogComponent } from '@b2b/features/misc/language-selector/languages-dialog/languages-dialog.component';
import { ModalService } from '@shared/components/modal-list/modal-list.service';

@Component({
  selector: 'btn-language',
  templateUrl: './btn-language.component.html',
  styleUrl: './btn-language.component.scss',
})
export class BtnLanguageComponent {
  constructor(private modalService: ModalService) {}

  showLanguagesDialog() {
    this.modalService.create({
      id: 'modal-language',
      title: '',
      component: LanguagesDialogComponent,
      width: 250,
    });
  }
}
